module.exports = __webpack_public_path__ + "static/media/16x20no3.bc7fa954.jpg";